<template>
  <div v-if="showFilters" class="py-3 bg-white fixed top-0 right-0 bottom-0 left-0 z-50 mb-32 overflow-y-auto">
    <div @click="showFilters = false" class="mt-3 absolute top-0 right-0 cursor-pointer"><svg fill="#a0aec0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="w-5 m-4"><path d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"></path></svg></div>
    <div class="leading-tight mx-6 text-lg font-bold mt-4 mb-4 border-b pb-4">{{ filterPageTitle }}</div>


    <ToggleBox class="px-6 mb-4" title="Rating">
      <div style="margin-right: -0.5rem;" class="border-b pb-4 mt-3 flex flex-wrap content-around items-stretch">
          <div class="flex-1 mb-2 mr-2">
            <input value="0" v-model="checkedRatings" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" id="rating0" :checked="true">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" for="rating0">0</label>
          </div>
          <div class="flex-1 mb-2 mr-2">
            <input value="1" v-model="checkedRatings" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" id="rating1">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" for="rating1">1</label>
          </div>
          <div class="flex-1 mb-2 mr-2">
            <input value="2" v-model="checkedRatings" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" id="rating2">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" for="rating2">2</label>
          </div>
          <div class="flex-1 mb-2 mr-2">
            <input value="3" v-model="checkedRatings" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" id="rating3">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" for="rating3">3</label>
          </div>
          <div class="flex-1 mb-2 mr-2">
            <input value="?"  v-model="checkedRatings" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" id="rating?">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" for="rating?">?</label>
          </div>
        </div>
    </ToggleBox>


    <div class="" v-for="cat in filterCategories" :key="cat.filterId">
      <ToggleBox class="px-6 mb-4" :title="cat.filterName" :open="cat.filterId == 'ADVANCED' ? false : true">
        <div style="margin-right: -0.5rem;" class="border-b pb-4 mt-3 flex flex-wrap content-around items-stretch">
          <div class="flex-1 mb-2 mr-2" v-for="(tType, tIndex) in cat.filterData" :key="`${cat.filterId}-${tIndex}`">
            <input checked="checked" @change="doChecked(cat.filterId + '_' + tIndex)" v-model="checkedBoxes" type="checkbox" class="filter-type-checkbox absolute w-0 h-0 opacity-0 invisible" :id="cat.filterId + '_' + tIndex" :value="cat.filterId + '_' + tIndex">
            <label class="filter-type-label text-center cursor-pointer whitespace-no-wrap bg-gray-200 text-gray-800 font-bold px-3 py-1 block" :for="cat.filterId + '_' + tIndex">{{ tType.n }}</label>
          </div>
        </div>
      </ToggleBox>
    </div>    
    <div class="bg-white fixed bottom-0 left-0 right-0 px-6 h-32 pt-5 bg-gray-100">
      <button @click="applyFilter" class="text-white bg-purple-600 hover:bg-purple-700 text-lg text-center w-full font-bold py-2">Apply Filters</button>
      <button @click="clearFilters" class="text-center hover:underline font-bold text-gray-800 w-full mt-2 py-2 bg-white">Clear all filters</button>
    </div>
  </div>
</template>

<script>
import ToggleBox from '@/components/ToggleBox.vue'

export default {
  components: {
    ToggleBox
  },
  data() {
    return {
      filterPageTitle: 'Filter results',
      showFilters: false,
      currentFilters: [],
      currentRatings: ['0', '1', '2', '3', '?'],
      checkedRatings: [],
      checkedBoxes: [],
      dietChoice: false,
      filterRatings: {
        'Well tolerated': '0', 'Moderately compatible': '1', 'Incompatible': '2', 'Very poorly tolerated': '3'
      },
      filterCategories: [{
        filterName: 'Basic',
        filterId: 'BASIC',
        filterData: [
          {n: 'Food', d: ['EGGS','DAIRY','MEAT','FISH','SEAFOOD','MISC','STARCH','NUTS','FATS','VEG','HERBS','FRUITS','SEEDS','FUNGI','SPICES','MIXTURES']},
          {n: 'Drinks', d: ['WATER', 'ALCOHOL', 'TEA', 'JUICES', 'CAFFEINE', 'OTHERMILKS', 'SOFTDRINKS']}/*,
          'Fruit & veg': ['FRUITS', 'VEG'],
          'Nuts & seeds': ['NUTS', 'SEEDS'],
          'Herbs & spices': ['HERBS', 'SPICES'],
          'Animal products': ['EGGS', 'DAIRY', 'MEAT', 'FISH', 'SEAFOOD']*/
        ]},
        {
          filterName: 'Dietary restrictions',
          filterId: 'DIET',
          filterData: [
            {n: 'Vegan', d: ['FRUITS', 'VEG', 'STARCHES', 'NUTS', 'FATS', 'HERBS', 'SEEDS', 'FUNGI', 'SPICES', 'WATER', 'ALCOHOL', 'TEA', 'JUICES', 'CAFFEINE', 'OTHERMILKS', 'SOFTDRINKS', 'MIXTURES']},
            {n: 'Vegetarian', d: ['EGGS', 'DAIRY', 'FRUITS', 'VEG', 'STARCHES', 'NUTS', 'FATS', 'HERBS', 'SEEDS', 'FUNGI', 'SPICES', 'WATER', 'ALCOHOL', 'TEA', 'JUICES', 'CAFFEINE', 'OTHERMILKS', 'SOFTDRINKS', 'MIXTURES']},
            {n: 'Pescetarian', d: ['FISH', 'SEAFOOD', 'EGGS', 'DAIRY', 'FRUITS', 'VEG', 'STARCHES', 'NUTS', 'FATS', 'HERBS', 'SEEDS', 'FUNGI', 'SPICES', 'WATER', 'ALCOHOL', 'TEA', 'JUICES', 'CAFFEINE', 'OTHERMILKS', 'SOFTDRINKS', 'MIXTURES']}
          ]},
        {
        filterName: 'Advanced',
        filterId: 'ADVANCED',
        filterData: [
          {n: 'Eggs', d: ['EGGS']}, {n: 'Dairy', d: ['DAIRY']}, {n: 'Meat', d: ['MEAT']}, {n: 'Fish', d: ['FISH']}, {n: 'Seafood', d: ['SEAFOOD']}, {n: 'Starches', d: ['STARCH']},
          {n: 'Nuts', d: ['NUTS']}, {n: 'Fats & oils', d: ['FATS']}, {n: 'Vegetables', d: ['VEG']}, {n: 'Herbs', d: ['HERBS']}, {n: 'Fruits', d: ['FRUITS']}, {n: 'Seeds', d: ['SEEDS']}, {n: 'Fungi', d: ['FUNGI']},
          {n: 'Spices', d: ['SPICES']}, {n: 'Water', d: ['WATER']}, {n: 'Alcohol', d: ['ALCOHOL']}, {n: 'Tea', d: ['TEA']}, {n: 'Juices', d: ['JUICES']}, {n: 'Caffeine', d: ['CAFFEINE']},
          {n: 'Plant milk', d: ['OTHERMILKS']}, {n: 'Soft drink', d: ['SOFTDRINKS']}, {n: 'Misc.', d: ['MIXTURES', 'MISC']}
        ]}
      ]
    }
  },
  props: {
    defaultFilters: {
      type: Array
    }
  },
  watch: {
    
  },
  mounted() {
    this.$root.$on('openFilterMenu', () => { 
      this.showFilters = true
      //this.$root.$emit('doFilter', [false, false])
      //this.$root.$emit('emptyFilter', true)
    })
    this.$root.$on('emptyFilter', () => { 
      this.currentFilters = []
      this.checkedBoxes = []
      this.checkedRatings = []
    })
  },
  methods: {
    applyFilter() {
      let tempFilters
      if (this.checkedBoxes.length > 1 || (this.checkedBoxes.length == 1 && !this.checkedBoxes[0].startsWith('DIET'))){
        // If 2 or more filters, or 1 filter that is not a diet filter
        tempFilters = []
        for (let theCount = 0; theCount < this.checkedBoxes.length; theCount++){
          let thisRef = this.checkedBoxes[theCount].split('_', 2)
          let tempId = thisRef[1]
          for (let a = 0; a < this.filterCategories.length; a++){
            if (thisRef[0] != 'DIET' && this.filterCategories[a].filterId == thisRef[0]){
              tempFilters.push.apply(tempFilters, this.filterCategories[a].filterData[tempId].d)
            }
          }
        }
        if (this.dietChoice) {
          let finalFilters = []
          for (let l = 0; l < tempFilters.length; l++) {
            let thisDiet = this.dietChoice.split('_', 2)
            let theD = thisDiet[1]
            if (this.filterCategories[1].filterData[theD].d.includes(tempFilters[l])){
              finalFilters.push(tempFilters[l])
            }
          }
          tempFilters = finalFilters
        }
      } else if (this.checkedBoxes.length == 1) {
        // One diet filter selected
        let thisDiet = this.dietChoice.split('_', 2)
        let theD = thisDiet[1]
        tempFilters = this.filterCategories[1].filterData[theD].d
      } else {
        // No filters selected
        tempFilters = false
      }
      


      if (this.checkedRatings.length == 0){
        this.currentRatings = ['0', '1', '2', '3', '?']
      } else {
        console.log("be checked")
        this.currentRatings = this.checkedRatings
      }

      this.$root.$emit('doFilter', [this.currentRatings, tempFilters])
      this.showFilters = false
    },
    clearFilters() {
      this.$root.$emit('doFilter', [false, false])
      this.$root.$emit('emptyFilter', true)
      this.showFilters = false
    },
    doChecked(theFilter) {
      if (this.checkedBoxes.includes(theFilter)){
        // theFilter has been checked
        this.addDiet(theFilter)
      } else{
        // theFilter has been unchecked
        if (theFilter.startsWith('DIET')){
          this.dietChoice = false
        }
      }
    },
    addDiet(theFilter) {
      if (theFilter.startsWith('DIET')){
        let tempArray = [];
        let lastItem = this.checkedBoxes[this.checkedBoxes.length - 1]
        for (let k = 0; k < this.checkedBoxes.length; k++){
          if (!this.checkedBoxes[k].startsWith('DIET')){
            tempArray.push(this.checkedBoxes[k])
          }
        }
        tempArray.push(lastItem)
        this.checkedBoxes = tempArray
        this.dietChoice = lastItem
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.filter-type-checkbox:checked ~ label{
  @apply bg-purple-600 text-white;
}
</style>
